import chatModule from '../chatModule';

const diagActionList = {
  ChatLandingConversationClickedWeb: 'ChatLandingConversationClickedWeb',
  ConversationMessageSentWeb: 'ConversationMessageSentWeb',
  WebChatConversationsLoadedWeb: 'WebChatConversationsLoadedWeb',
  WebChatRenderedWeb: 'WebChatRenderedWeb'
};

chatModule.constant('diagActionList', diagActionList);

export default diagActionList;
